import { render, staticRenderFns } from "./Footer2.vue?vue&type=template&id=476c5802&"
import script from "./Footer2.vue?vue&type=script&lang=js&"
export * from "./Footer2.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports